import Navbar from "./components/Navbar";
import AppNav from "../../App/AppNav/AppNav";
import DiscoverPageMain from "./components/DiscoverPageMain";
import TripPlannerForm from "./components/trip_planner/TripPlannerForm";
import FeaturedDestinations from "./components/FeaturedDestinations";
import FeaturedItineraries from "./components/FeaturedItineraries";
import Footer from "./components/Footer";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useTranslate from "../../hooks/useTranslate";
import {useSelector} from "react-redux";
import ICombinedState from "../../redux/model/ICombinedState";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import {REGISTER, TRIPS} from "../../constants/ROUTER_PATH_TITLE";

const TripPlanner = () => {

    const { language } = useParams();
    const formattedLanguage = language
        ? language.toUpperCase() === "PT-BR"
            ? "pt-BR"
            : language.split("-")[0].toLowerCase()
        : undefined;

    const { t, onSelectedLangCode, langCode } = useTranslate();
    useEffect(() => {
        const langCodeKeys: string[] = window.tconfig.T.langCodes.map(l => l.value);

        if (formattedLanguage && langCodeKeys.includes(formattedLanguage)) {
            onSelectedLangCode(formattedLanguage);
        }
    }, [formattedLanguage, onSelectedLangCode]);

    const isLoggedIn = useSelector(
        (state: ICombinedState) => state.user.isLoggedIn
    );

    const { getLocalData } = useLocalStorage<"light" | "dark">("theme");
    const theme = getLocalData();
    const isValaiLanding = window.tconfig.LANDING_PAGE === "ValaiLanding";
    const navigate = useNavigate();
    const onClickSignUp = () => {
        if (isLoggedIn) {
            navigate(TRIPS.PATH);
        } else {
            if (window.tconfig.SHOW_REGISTER) {
                navigate(REGISTER.PATH);
            }
        }
    };
    return (
        <>
            <div className="min-h-screen font-geist text-[#0B1215]">
                {isValaiLanding ? (
                    <Navbar
                        theme={theme}
                        t={t}
                    />
                ) : (
                    <AppNav header="" />
                )}
                <main className="container mx-auto py-12">
                    <TripPlannerForm />
                </main>
                {isValaiLanding && <Footer t={t} />}

            </div>
        </>
    );

}
export default TripPlanner;